import { render, staticRenderFns } from "./initReward.vue?vue&type=template&id=84986f06&scoped=true&"
import script from "./initReward.vue?vue&type=script&lang=js&"
export * from "./initReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84986f06",
  null
  
)

export default component.exports